import { QUALIFICATION_CHECK_STATUS } from '../constants';

export const AllQualificationsFilter = {
  qualificationCheckStatus: {
    in: [
      QUALIFICATION_CHECK_STATUS.CREATED,
      QUALIFICATION_CHECK_STATUS.CHECKING,
      QUALIFICATION_CHECK_STATUS.MODIFICATION_REQUIRED,
    ],
  },
};
